@if (visible$ | async) { @if (isPriceRange$ | async) { @if (data$ | async; as d) {
<div class="current-price" data-testing-id="current-price">
  {{ d.lowerPrice | ishPrice }} - {{ d.upperPrice | ishPrice }}
</div>
} } @else { @if (data$ | async; as d) {
<div
  [id]="'priceElementId' + range()"
  class="current-price"
  [ngClass]="{
    'sale-price': showInformationalPrice() && d.isListPriceGreaterThanSalePrice,
    'sale-price-higher': showInformationalPrice() && d.isListPriceLessThanSalePrice
  }"
  data-testing-id="current-price"
>
  @if (d.salePrice) {
  {{
    (d.isListPriceGreaterThanSalePrice ? 'product.price.salePricePrefix.text' : 'product.price.salePriceFallback.text')
      | translate : { '0': d.salePrice | ishPrice }
  }}
  <meta itemprop="price" [attr.content]="d.salePrice.value | number : '1.2-2' : 'en_US'" />
  <meta itemprop="priceCurrency" [attr.content]="d.salePrice.currency" />
  } @else {
  {{ 'product.price.na.text' | translate }}
  }
</div>
@if (showInformationalPrice() && d.isListPriceGreaterThanSalePrice) {
<div class="old-price" data-testing-id="old-price">
  <span class="price-value">
    {{ 'product.price.listPriceFallback.text' | translate : { '0': d.listPrice | ishPrice } }}
  </span>
  @if (showPriceSavings()) {
  <span class="price-savings">
    {{ 'product.price.savingsFallback.text' | translate : { '0': d.priceSavings | ishPrice } }}
  </span>
  }
</div>
} @if (showScaledPrices() && d.scaledPrices?.length) {
<div class="scaled-prices" data-testing-id="scaled-prices">
  @for (scaledPrice of d.scaledPrices; track scaledPrice; let i = $index; let lastScaledPrice = $last) { @if
  (lastScaledPrice) {
  <div>
    {{
      'product.price.scaledPrice.text.last' | translate : { '0': scaledPrice.minQuantity, '1': scaledPrice | ishPrice }
    }}
  </div>
  } @else { @if (scaledPrice.minQuantity !== d.scaledPrices[i + 1].minQuantity - 1) {
  <div>
    {{
      'product.price.scaledPrice.text'
        | translate
          : {
              '0': scaledPrice.minQuantity,
              '1': d.scaledPrices[i + 1].minQuantity - 1,
              '2': scaledPrice | ishPrice
            }
    }}
  </div>
  } @else {
  <div>
    {{
      'product.price.scaledPrice.single.text'
        | translate
          : {
              '0': scaledPrice.minQuantity,
              '1': scaledPrice | ishPrice
            }
    }}
  </div>
  } } }
</div>
} } } }
